module.exports = __webpack_public_path__ + "static/media/private_events.6637bfe7.svg";